import { useTranslation } from "@/components/LanguageContext";

const partners = [
  { name: "EASA", src: "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/0a0pgq4o_EASA_Logo.png" },
  { name: "AESA", src: "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/rmsomp49_AESA_Logo.png", height: "h-20" },
  { name: "Atlantic Airways", src: "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/stc2qkbv_Atlantic_Airways-Logo.wine.png", height: "h-32" },
  { name: "ANAC", src: "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/gcg6pa6g_logo-anac.png", height: "h-20" },
  { name: "SUNTECH", src: "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/jddsox7w_SUNTECH-low.png" },
  { name: "UK CAA", src: "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/0ods5yuz_UK_Civil_Aviation_Authority_logo.svg.png", height: "h-16" },
];
const doubled = [...partners, ...partners, ...partners, ...partners];

export default function PartnershipsSection() {
  const { t } = useTranslation();
  return (
    <section id="parcerias" data-testid="partnerships-section" className="py-24 md:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A8FF] mb-2">{t("partnerships.label")}</p>
        <div className="section-divider mx-auto mb-6" />
        <h2 className="font-['Outfit'] text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A1628] mb-4">{t("partnerships.title")}</h2>
        <p className="text-base text-slate-500 mb-16 max-w-xl mx-auto leading-relaxed">{t("partnerships.desc")}</p>
      </div>
      <div className="marquee-wrapper">
        <div className="marquee-fade-left" />
        <div className="marquee-fade-right" />
        <div className="marquee-track flex items-center gap-20 animate-marquee">
          {doubled.map((p, i) => (
            <img key={i} src={p.src} alt={p.name} className={`${p.height || "h-14"} w-auto max-w-[260px] object-contain shrink-0`} style={{ mixBlendMode: "multiply" }} data-testid={`partner-card-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
